// Shared by CompanionPanel (auto-speak) and ModelsPanel (reasoning toggles) —
// relocated from SettingsPanel.tsx unchanged, plus an accessible-name prop
// (Harmony finding: a bare role="switch" button has no name of its own —
// AT hears "switch, on/off" with nothing to distinguish which setting it is).
export function ToggleSwitch({
  checked,
  onChange,
  labelledBy,
}: {
  checked: boolean
  onChange: () => void
  /** id of the sibling label element (e.g. .settings-row-label) this switch controls. */
  labelledBy: string
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-labelledby={labelledBy}
      className={`settings-toggle ${checked ? "on" : ""}`}
      onClick={onChange}
    />
  )
}
